import React, { useContext, createContext } from "react"
import lodash from "lodash"

const UserModulesContext = createContext({ userModules: [] })

export const UserModulesContextProvider = props => {
  return <UserModulesContext.Provider {...props} />
}

export const useUserModules = () => {
  const { userModules } = useContext(UserModulesContext)

  return lodash.isArray(userModules) ? userModules : []
}
